import styled from 'styled-components'
import triangle from 'assets/svg/triangle.svg'

const height = '18px'

export const SwitchWrapper = styled.div`
  position: relative;
`

export const SwitchDot = styled.label`
  background: ${({ theme }) => theme.bg3};
  border-radius: 15px;
  cursor: pointer;
  height: 25px;
  left: 0;
  position: absolute;
  top: 0;
  transition: ${({ theme }) => theme.TRANSITION.fast};
  width: 42px;

  &::after {
    background-image: url(${triangle});
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
    content: '';
    display: block;
    height: ${height};
    margin: 3px;
    transition: ${({ theme }) => theme.TRANSITION.fast};
    width: 18px;
  }
`

export const SwitchInput = styled.input`
  height: 18px;
  opacity: 0;
  width: 42px;

  &:checked + ${SwitchDot} {
    &::after {
      border-radius: 50%;
      content: '';
      display: block;
      height: ${height};
      margin-left: 21px;
      transform: rotate(180deg);
      transition: ${({ theme }) => theme.TRANSITION.fast};
      width: 18px;
    }
  }
`
